import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/styles';
import styles from '../../assets/jss/FormStyle';

function PageLoader(props) {
  const { classes, isLoading } = props;

  return (
    <div>
      {isLoading ? (
        <div className={classes.pageLoader}>
          <CircularProgress className={classes.svg} variant="indeterminate" />
        </div>
      ) : (
        ''
      )}
    </div>
  );
}

export default withStyles(styles, { withTheme: true })(PageLoader);
